import chalk, { ColorName } from 'chalk';

const useConsoleError =
  (colorName: ColorName) =>
  (...input: Parameters<typeof console.error>) => {
    console.error(...input.map((item) => chalk[colorName](item)));
  };

const output = {
  info: useConsoleError('green'),
  log: useConsoleError('white'),
  warn: useConsoleError('yellow'),
  error: useConsoleError('red'),
};

export default output;
